import { render, staticRenderFns } from "./AutoInfracaoIpaam.vue?vue&type=template&id=3e8405bd&lang=pug"
import script from "./AutoInfracaoIpaam.vue?vue&type=script&lang=js"
export * from "./AutoInfracaoIpaam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports